import React from 'react';
import { Left, Title } from './styled';
import { Text, Div, QRDownload } from 'components/Atoms';
import { useTranslation } from 'react-i18next';
import useResponsive from 'utils/hooks/useResponsive';
import { ReactComponent as LogoAppleStore } from "assets/app-store.svg";
import { ReactComponent as LogoPlayStore } from "assets/play-store.svg";
import { Logo } from 'ui'
import { isAndroid, isIOS } from 'react-device-detect';
import { GAHandler } from 'utils/GA';

const Index = () => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();
  const androidStore = 'https://play.google.com/store/apps/details?id=com.flixxo.apps.flixxoapp&hl=en_US';
  const appleStore = 'https://apps.apple.com/us/app/flixxo/id1447682880';

  const handleClick = (store) => {
    GAHandler(`ui_store_${store}`);
  }

  return (
    <Left>
      <Logo scale={1.2} />
      <Title>{t("liveFullExperience")}</Title>
      {!isMobile && (
        <>
          <Text textAlign="center">{t("scanCodeQR")}</Text>
          <Text marginTop="-16px" textAlign="center">{t("fromYourMobilePhone")}</Text>
        </>
      )}
      
      {(isAndroid) && (
        <a
          href={androidStore}
          onClick={() => handleClick('android')}
          onAuxClick={() => handleClick('android')}
        >
          <Div marginTop={isMobile && "16px"}>
            <LogoPlayStore/>
          </Div>
        </a>
      )}

      {(isIOS) && (
        <a
          href={appleStore}
          onClick={() => handleClick('apple')}
          onAuxClick={() => handleClick('apple')}
        >
          <Div marginTop={isMobile && "16px"}>
            <LogoAppleStore/>
          </Div>
        </a>
      )}

      {(!isAndroid && !isIOS) && (
        <>
          <QRDownload/>
          <Text>{t("availableOn")}</Text>
          <Div display="flex" alignItems="center" gap="16px" marginTop={isMobile && "16px"}>
            <a
              href={appleStore}
              target='_blank'
              rel='noopener noreferrer'
              onClick={() => handleClick('Apple')}
              onAuxClick={() => handleClick('Apple')}
            >
              <LogoAppleStore width='100%' />
            </a>

            <a
              href={androidStore}
              target='_blank'
              rel='noopener noreferrer'
              onClick={() => handleClick('Android')}
              onAuxClick={() => handleClick('Android')}
            >
              <LogoPlayStore width='100%' />
            </a>
          </Div>
        </>
      )}
    </Left>
  )
}

export default Index
